import path from 'path'
import fs from 'fs'

// Production sites directory (where resources/images/db live on the server)
export const PROD_SITES_DIR = '/var/www/portfolio-sites'

export function getSiteName() {
    return process.env.SITE || 'tofjan.online'
}

/** True when running on the server with the production sites directory present. */
export function useProdSitePaths() {
    return process.env.NODE_ENV === 'production' && fs.existsSync(PROD_SITES_DIR)
}

/**
 * Single codebase, multiple sites.
 * Everything is resolved relative to repo root (process.cwd()) and the SITE env var.
 * 
 * In production, site resources (images, database, assets) are stored separately
 * at /var/www/portfolio-sites/{site}/resources/ to allow independent deployment
 * of code vs. content.
 */
export function getSitePaths(site = getSiteName(), rootDir = process.cwd()) {
    const isProd = useProdSitePaths()
    const siteDir = path.resolve(rootDir, 'sites', site)
    
    // On the server, resources live separately from the codebase; locally always use ./sites
    const resourcesBase = isProd ? PROD_SITES_DIR : path.resolve(rootDir, 'sites')
    const resourcesDir = path.join(resourcesBase, site, 'resources')
    // Glyph drawings are shared by every site, not stored inside one site.
    const sharedResourcesDir = path.join(resourcesBase, '_shared', 'resources')

    return {
        site,
        rootDir,
        siteDir,
        resourcesDir,
        /** Parent of every site's resources dir (`sites` locally, `/var/www/portfolio-sites` in prod). */
        sitesRoot: resourcesBase,
        sharedResourcesDir,
        glyphsDir: path.join(sharedResourcesDir, 'glyphs'),
        glyphsJsonPath: path.join(sharedResourcesDir, 'glyphs.json'),

        // Site-specific .env file (stays with codebase for config, but can also be in resources)
        envPath: isProd
            ? path.join(resourcesBase, site, '.env')
            : path.join(siteDir, '.env'),

        // Shared public directory (all sites)
        sharedPublicDir: path.join(rootDir, 'public'),

        // Site-specific assets (override shared public)
        assetsDir: path.join(resourcesDir, 'assets'),
        imagesDir: path.join(resourcesDir, 'images'),
        tempDir: path.join(resourcesDir, 'temp'),
        dbBackupDir: path.join(resourcesDir, 'db'),

        dbJsonPath: path.join(resourcesDir, 'db', 'website.json'),
        dbSqlitePath: path.join(resourcesDir, 'website.db'),
    }
}

